<template>
    <card>
      <template slot="header">
        <h3 class="card-title">Edit Dependent</h3>
      </template>
      <nav class="row">
        <ol class="breadcrumb arr-right bg-breadcrum">
          <li class="breadcrumb-item">
            <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/hr/dependents">Dependent List</router-link>
          </li>
          <li class="breadcrumb-item active">Edit Dependent</li>
        </ol>
      </nav>
      <hr style="margin-top:-10px" />
      <!-- Experience TO DO HERE -->
      <form @submit.prevent="update_form">
        <div class="col-md-12">
          <div class="form-group">
            <div class="row">
              <div class="col-md-3">
                <h2 class="text-right"><i>{{item.fullname | capitalize}}</i></h2>
              </div>
              <div class="col-md-6"></div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-md-3">
                <h3 class="text-right"><u>Dependent</u></h3>
              </div>
              <div class="col-md-6"></div>
            </div>
          </div>
          <div v-for="dep in item.dependents">
            <div class="form-group">
              <div class="row">
                <p class="col-md-2 text-right p-text">Name :</p>
                <div class="col-md-4">
                  <input type="text" v-model="dep.name" class="form-control">
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <p class="col-md-2 text-right p-text">Relationship :</p>
                <div class="col-md-4">
                  <input type="text" v-model="dep.relationship" class="form-control">
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <p class="col-md-2 text-right p-text">Age :</p>
                <div class="col-md-1">
                  <input type="text" v-model="dep.age" class="form-control">
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <p class="col-md-2 text-right p-text">phic :</p>
                <div class="col-md-2">
                  <input type="text" v-model="dep.phic_no" class="form-control">
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-md-3">
                <h3 class="text-right"><u>Senior Dependent</u></h3>
              </div>
              <div class="col-md-6"></div>
            </div>
          </div>
          <div v-for="sen in item.seniors">
            <div class="form-group">
              <div class="row">
                <p class="col-md-2 text-right p-text">Senior citizen :</p>
                <div class="col-md-2">
                  <input type="text" v-model="sen.senior_citizen" class="form-control">
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <p class="col-md-2 text-right p-text">Middle initial :</p>
                <div class="col-md-2">
                  <input type="text" v-model="sen.middle_initial" class="form-control">
                </div>
              </div>
            </div>
          </div>
          <!-- button submit -->
          <div class="form-group">
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-sm-4">
                  </div>
                  <div class="col-sm-3">
                    <button class="btn btn-info"><i class="fa fa-save"></i>&nbsp;Save Changes</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </card>
  </template>
<script>
   /* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
  components: {
    Card
  },
  data() {
    return {
      item: '',
      dependents: [{
        name: '',
        relationship: '',
        age: '',
        phic_no: ''
      }],
      seniors: [{
        senior_citizen: '',
        middle_initial: ''
      }],

    }
  },
  mounted: function () {
    this.getEmployeeInfo()
  },
  methods: {
    getEmployeeInfo() {
      axios.get('api/dependents/get/' + this.$route.params.id)
        .then(response => {
          this.item = response.data;
        })
        .catch(error => {
          console.log(error)
        });
    },


    update_form(e) {
      e.preventDefault();
      this.$swal({
          title: 'Are you sure?',
          text: 'Do you want to save changes.',
          type: 'warning',
          showCancelButton: true,
          showCloseButton: false,
        })
        .then((isConfirm) => {
          if (isConfirm === true) {
            axios.post('api/dependents/update/' + this.item.id, {
                //Update experience
                dependents: this.item.dependents,
                seniors: this.item.seniors

              })
              .then(response => {
                this.$swal({
                  type: 'success',
                  title: 'Save',
                  text: 'You successfully save changes',
                  showConfirmButton: false,
                  timer: 2000
                })

                this.$router.push({
                  name: 'dependents'
                });
                console.log(response.data)
              })
              .catch(e => {
                console.log(e.response)
              })
          }
        });
    }
  },

}
</script>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-edit-dependents.vue